import { heroStats } from '@/mocks/donnos';

export default function HeroSection() {
  return (
    <section id="inicio" className="relative min-h-[620px] md:min-h-screen bg-donnos-dark overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="/assets/donnos-hero.png"
          alt="Equipamentos de tecnologia em ambiente de data center"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-[#020b16] via-[#063c43]/78 to-[#020b16]/15"></div>
        <div className="absolute inset-0 bg-gradient-to-t from-[#020b16] via-transparent to-[#063c43]/45"></div>
      </div>

      <div className="absolute top-0 right-[28%] w-0.5 h-full bg-gradient-to-b from-transparent via-donnos-green/80 to-transparent hidden lg:block"></div>
      <div className="absolute top-0 right-[28%] w-3 h-full bg-gradient-to-b from-transparent via-donnos-green/30 to-transparent blur-lg hidden lg:block"></div>
      <div className="absolute top-0 right-[28%] w-12 h-full bg-gradient-to-b from-transparent via-donnos-green/15 to-transparent blur-2xl hidden lg:block"></div>

      <div className="relative z-10 w-full px-4 sm:px-6 md:px-8 lg:px-12 pt-24 sm:pt-28 md:pt-32 pb-12 md:pb-16">
        <div className="flex flex-col lg:flex-row items-center justify-between gap-6 lg:gap-8">
          <div className="max-w-2xl w-full pt-8 md:pt-12 lg:pt-20">
            <h1 className="text-2xl sm:text-3xl md:text-5xl lg:text-[3.5rem] font-bold text-white leading-tight mb-4 md:mb-6">
              Soluções inteligentes em{' '}
              <span className="text-donnos-green">tecnologia</span>{' '}
              para empresas e órgãos públicos
            </h1>
            <p className="text-sm sm:text-base md:text-lg text-gray-300 mb-6 md:mb-8 max-w-xl leading-relaxed">
              A Donnos oferece equipamentos, suprimentos e serviços integrados com agilidade, confiança e atendimento especializado.
            </p>
            <div className="flex flex-col sm:flex-row flex-wrap gap-3 md:gap-4 mb-8 md:mb-12">
              <a
                href="#contato"
                className="inline-flex items-center justify-center gap-2 bg-donnos-green hover:bg-donnos-green-dark text-white font-semibold px-5 md:px-6 py-3 rounded-md transition-colors whitespace-nowrap"
              >
                <i className="ri-file-list-3-line"></i>
                Solicitar orçamento
              </a>
              <a
                href="#atas"
                className="inline-flex items-center justify-center gap-2 border-2 border-white/30 hover:border-white text-white font-semibold px-5 md:px-6 py-3 rounded-md transition-colors whitespace-nowrap"
              >
                <i className="ri-file-list-3-line"></i>
                Consulta de Atas
              </a>
            </div>
          </div>

          <div className="hidden lg:block relative w-[440px] xl:w-[560px] 2xl:w-[640px] shrink-0" aria-hidden="true"></div>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-0 mt-6 md:mt-4">
          {heroStats.map((stat, index) => (
            <div key={index} className="flex items-center">
              <div className="flex flex-col items-center text-center px-2 sm:px-4 md:px-8 lg:px-10 py-3 md:py-4 w-full">
                <i className={`${stat.icon} text-donnos-green text-2xl sm:text-3xl md:text-4xl mb-2 md:mb-3`}></i>
                <div className="text-lg sm:text-xl md:text-2xl lg:text-[1.75rem] font-bold text-white mb-1">
                  {stat.value}
                </div>
                <p className="text-xs text-gray-400 max-w-[140px] md:max-w-[150px] leading-tight">{stat.description}</p>
              </div>
              {index < heroStats.length - 1 && (
                <div className="hidden md:block w-px h-16 md:h-20 bg-white/20 self-center"></div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
